import Super from '@simplepractice/ember-messaging-client/adapters/messaging-profile';

export default Super.extend({});
